<template>
  <div id="app">
    <el-row>
      <el-col :offset="1" :span="1" style="padding-bottom:40px">
        <img src="./assets/sp.png">
      </el-col>
      <el-col :span="16" :offset="2">
        <el-menu mode="horizontal">
          <el-menu-item>
            <router-link to="/tickets">Tickets</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/users">Users</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/companies">Locations</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/summary">Summary</router-link>
          </el-menu-item>
          <el-menu-item style='float:right;'>
            <div v-if="win.sessionStorage.getItem('token')"  @click="logout()" style="cursor:pointer;">Logout</div>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "app",
  data(){
    return {
    win: window
    };
  },

  components: {},
  methods: {
    logout() {
      window.sessionStorage.removeItem('token')
      this.$router.push("/login");
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body,
html {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
